<!-- // broadcast-overlay.component.html -->
<div class="broadcast-overlay-container" *ngIf="isVisible && isAuth" @slideDown>
  <div class="marquee-wrapper">
    <div class="marquee-content">
      <span class="marquee-text">{{ displayText }}</span>
      <span class="marquee-text">{{ displayText }}</span>
    </div>
  </div>
  
  <div class="action-buttons">
    <button class="btn btn-detail" (click)="openDetail()" title="View Details">
      <span>📋</span>
    </button>
    <button class="btn btn-close" (click)="closeOverlay()" title="Close">
      <span>✕</span>
    </button>
  </div>
</div>

<!-- Show Messages Button (when overlay is hidden) -->
<button 
  class="btn-show-messages" 
  *ngIf="!isVisible && messages.length > 0" 
  (click)="showOverlay()"
  @fadeIn
  title="Show broadcast messages">
  <span class="icon">📢</span>
  <span class="text">{{ messages.length }} Message{{ messages.length > 1 ? 's' : '' }}</span>
</button>

<!-- Detail Modal -->
<div class="detail-overlay" *ngIf="showDetail" @fadeIn (click)="closeDetail()">
  <div class="detail-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h3>Messages de diffusion</h3>
      <button class="btn-icon" (click)="closeDetail()">✕</button>
    </div>
    
    <div class="modal-body" *ngIf="!selectedMessage">
      <div class="message-list">
        <div 
          class="message-item" 
          *ngFor="let msg of messages"
          (click)="viewMessageDetail(msg)">
          <div class="message-title">{{ msg.libelle }}</div>
          <div class="message-preview">{{ msg.message }}</div>
          <div class="message-has-image" *ngIf="msg.image_url">
            📷 Une image associée
          </div>
        </div>
      </div>
    </div>

    <div class="modal-body" *ngIf="selectedMessage">
      <button class="btn-back" (click)="backToList()">← Revenir à la liste</button>
      <div class="message-detail">
        <h4>{{ selectedMessage.libelle }}</h4>
        <p>{{ selectedMessage.message }}</p>
        
        <div class="image-preview" *ngIf="selectedMessage.image_url">
          <button class="btn-view-image" (click)="viewImage(selectedMessage.image_url!)">
            <span class="icon">🖼️</span>
            <span>Voir l'image associée</span>
          </button>
        </div>
        
        <div class="message-meta" *ngIf="selectedMessage.date">
          <small>Date: {{ selectedMessage.date | date:'medium' }}</small>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Image Viewer Modal -->
<div class="image-viewer-overlay" *ngIf="showImageViewer" @fadeIn (click)="closeImageViewer()">
  <div class="image-viewer-container">
    <button class="btn-close-viewer" (click)="closeImageViewer()">✕</button>
    <img [src]="currentImage" alt="Broadcast Image" (click)="$event.stopPropagation()">
  </div>
</div>